import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Header from "../components/Header";
import Hero from "../components/Hero";
import TrustBar from "../components/TrustBar";
import About from "../components/About";
import FounderSpotlight from "../components/FounderSpotlight";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import LeadCapture from "../components/LeadCapture";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import WhatsAppWidget from "../components/WhatsAppWidget";
import SEO from "../components/SEO";

const LandingPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: isLoaded ? 1 : 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen"
    >
      <SEO 
        title="Mheshe Attorneys Inc | Property Development & Specialist Conveyancing | Gqeberha & Johannesburg"
        description="Mheshe Attorneys is a specialist, 100% black woman-owned legal practice providing integrated legal support across the property development lifecycle. From land acquisition to final transfer — specialist conveyancing, notarial services, commercial agreements and governance advisory. Offices in Gqeberha, Johannesburg and Cape Town."
        url="https://mhesheattorneys.co.za"
      />
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <About />
        <FounderSpotlight />
        <Services />
        <WhyChooseUs />
        <LeadCapture />
        <Testimonials />
        <Footer />
      </main>
      <WhatsAppWidget />
    </motion.div>
  );
};

export default LandingPage;
